<div class="research-container">
  <shared-analyst-notes
    [runningNotes]="pkg()?.running_analyst_notes"
    [threatDescription]="pkg()?.context?.threat_description ?? ''"
  ></shared-analyst-notes>
</div>
